module.exports = __webpack_public_path__ + "static/media/information-icon.fcc7fb65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/information-icon.svg
// module id = 614
// module chunks = 0